import { Pressable, StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';

import { Badge, DefaultLayout, Text, WebCard, colors, spacing } from '@pletly/ui';
import PlusIcon from '%assets/icons/add-post.svg';
import { Groups } from './components/Groups';

export default function () {
	const { t } = useTranslation();
	const { navigate } = useNavigation();

	return (
		<DefaultLayout view>
			<WebCard style={styles.container}>
				<View style={styles.header}>
					<Badge value={t('common.beta')}>
						<Text category="h1" align="center">
							{t('community.communities')}
						</Text>
					</Badge>

					<Pressable onPress={() => navigate('NewCommunity')}>
						<PlusIcon />
					</Pressable>
				</View>

				<Groups />
			</WebCard>
		</DefaultLayout>
	);
}

const styles = StyleSheet.create({
	container: {
		gap: spacing(4),
		width: '100%',
		backgroundColor: colors.transparent,
	},
	header: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignContent: 'center',
	},
});
